import { isServer } from 'src/utils/index'
import _pick from 'lodash/pick'
import { IncomingHttpHeaders } from 'http'
import { AxiosRequestHeaders } from 'axios'

import { envEnum, getEnv } from 'src/utils/crossEnv'

export const prepareHeaders = (headers?: IncomingHttpHeaders): AxiosRequestHeaders => {
  const env = getEnv(envEnum.NEXT_PUBLIC_ENVIRONMENT)
  const headerNamesProd = ['x-user-id', 'x-host'] // for PROD and RC
  const headerNamesDev = ['x-guest-key', 'x-user-authenticated', 'x-user-id', 'x-host', 'cookie'] // for DEV

  const headerNames = env.startsWith('prod') || env.startsWith('rc') ? headerNamesProd : headerNamesDev

  return ((isServer && headers && _pick(headers, headerNames)) || {}) as AxiosRequestHeaders
}
